import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAnchor, MatIconAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { LaunchAppUrlToken } from './launch-app-url';

@Component({
  selector: 'app-launch-app-button',
  imports: [CommonModule, MatAnchor, MatIcon, MatIconAnchor, TranslateModule],
  templateUrl: './launch-app-button.component.html',
  styleUrl: './launch-app-button.component.scss',
})
export class LaunchAppButtonComponent {
  protected readonly appUrl$ = inject(LaunchAppUrlToken);
}
